<template>
  <span class="details-tab">
    <!-- <BButton v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="btn-icon" @click="onCreate()">
      <FeatherIcon icon="UserPlusIcon" />
    </BButton>
    <BButton v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="btn-icon" @click="onDelete()">
      <FeatherIcon icon="TrashIcon" />
    </BButton> -->
  </span>
</template>

<script>
// import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import { mapState } from 'vuex'

export default {
  // components: { BButton },
  directives: {
    Ripple
  },
  data: function () {
    return {
      showPermissionsModal: false,
      showConversationModal: false,
      showMoveModal: false,
      entityType: ''
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    onCreate() {},
    onDelete() {}
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables/_variables';
.btn-icon {
  border: none !important;
  padding: 0 !important;
  margin: 1px !important;
  color: $purple !important;
  background: transparent !important;
}
.btn-icon:hover:enabled {
  background: $purple !important;
  color: white !important;
}
.btn-icon svg {
  width: 16px !important;
  height: 16px !important;
  margin: 0.8em !important;
}
</style>
